module.exports = __webpack_public_path__ + "img/Home-Insurama-10.23e79cc9.png";